// src/core/imcmd/DefaultUiCommand.ts
/**
 * Системные команды для универсальных DOM-операций (namespace = "default").
 *
 * ВАЖНО! Значеняи в lowercase использовать, а ключи как удобно
 */
var DefaultUiCommand;
(function (DefaultUiCommand) {
    // ── Классы ───────────────────────────────
    /** Добавить CSS-класс на выбранные элементы */
    DefaultUiCommand["addClass"] = "addclass";
    /** Удалить CSS-класс с выбранных элементов */
    DefaultUiCommand["removeClass"] = "removeclass";
    /** Переключить наличие CSS-класса */
    DefaultUiCommand["toggleClass"] = "toggleclass";
    /** Поставить временный класс и убрать через задержку */
    DefaultUiCommand["tempClass"] = "tempClass";
    // ── Манипуляции с DOM ────────────────────────────
    /** Вставка внутрь элемента в начале */
    DefaultUiCommand["prepend"] = "prepend";
    /** Вставить внутрь элемента в конце */
    DefaultUiCommand["append"] = "append";
    /** Вставить после элемента */
    DefaultUiCommand["after"] = "after";
    /** Замена элемента */
    DefaultUiCommand["replace"] = "replace";
    /** Замена внутреннего контента элемента */
    DefaultUiCommand["replaceInner"] = "replaceinner";
    /** Удаление элемента */
    DefaultUiCommand["remove"] = "remove";
    /** Перемещение элементов вверх */
    DefaultUiCommand["htmlMoveUp"] = "htmlmoveup";
    /** Перемещение элементов вниз */
    DefaultUiCommand["htmlMoveDown"] = "htmlmovedown";
    // ── Видимость ────────────────────────────
    /** Сделать элементы видимыми */
    DefaultUiCommand["show"] = "show";
    /** Скрыть элементы */
    DefaultUiCommand["hide"] = "hide";
    /** Переключить видимость */
    DefaultUiCommand["toggle"] = "toggle";
    // ── Фокус ────────────────────────────────
    /** Установить фокус на элемент */
    DefaultUiCommand["focus"] = "focus";
    // ── События / навигация / буфер ─────────
    /** Вызвать системное событие (через ImViewBridge) */
    DefaultUiCommand["event"] = "event";
    /** Скопировать значение элемента в буфер обмена */
    DefaultUiCommand["copyToClip"] = "copytoclip";
    /** Перенаправить браузер на указанный адрес */
    DefaultUiCommand["redirect"] = "redirect";
    // ── Значения ────────────────────────────
    /** Установить значение элемента (input, textarea, checkbox) */
    DefaultUiCommand["setval"] = "setval";
    /** Скопировать значение из одного элемента в другой */
    DefaultUiCommand["setvalFrom"] = "setvalfrom";
    /** Очистить значение элемента */
    DefaultUiCommand["clr"] = "clr";
    DefaultUiCommand["setAttribute"] = "setattribute";
    // ── Управление элементами ───────────────
    /** Закрыть всплывающее окно (popup) */
    DefaultUiCommand["closePopup"] = "closepopup";
    /** Прокрутить к элементу */
    DefaultUiCommand["scrollTo"] = "scrollto";
    /** Запустить процесс с отслеживанием */
    DefaultUiCommand["showProcess"] = "showprocess";
    /** Открытие диалогового окна */
    DefaultUiCommand["openForm"] = "openform";
    /** Открытие д*/
    DefaultUiCommand["openInPlace"] = "openinplace";
    /** Открытие в боковой панели */
    DefaultUiCommand["openAside"] = "openaside";
    /** Показ сообщения в инлайновом алерте, если указано где, иначе обычный алерт */
    DefaultUiCommand["alert"] = "alert";
    /** Активировать нужный таб */
    DefaultUiCommand["activeTab"] = "activetab";
})(DefaultUiCommand || (DefaultUiCommand = {}));

export { DefaultUiCommand };
